import React from 'react';

import './Switch.scss';

interface YatSwitchProps {
    onChange: () => void;
    id: string;
    label?: string;
    checked: boolean;
}

const YatSwitch = ({ id, checked, onChange, label = '' }: YatSwitchProps) => {
    return (
        <div className="yat-switch">
            <input type="checkbox" checked={checked} id={id} onChange={onChange} />
            <label htmlFor={id}>{label}</label>
        </div>
    );
};

export default YatSwitch;
